<template>
  <div id="app" class="mars-box-view show-flex-box-c">
    <div class="mars-box-header">
      <keep-alive>
        <storeHeader
          v-if="curPosition == 'store' || curPosition == 'management' || curPosition == 'redemption'"
        ></storeHeader>
        <insHeader
          v-else-if="curPosition == 'ins' || curPosition == 'management' || curPosition == 'ins_personal_center'"
        ></insHeader>
        <insForumHeader v-else-if="curPosition == 'teacherForum'"></insForumHeader>
        <scratchPersonalHeader v-else-if="curPosition == 'scratch_personal'"></scratchPersonalHeader>
        <scratchProgramHeader v-else-if="curPosition == 'scratch_program'"></scratchProgramHeader>
        <marsBoxHomeHeader v-else></marsBoxHomeHeader>
      </keep-alive>
    </div>
    <div class="mars-box-center">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
    </div>
    <div class="mars-box-footer" v-if="curPosition != 'management'">
      <keep-alive>
        <marsBoxFooter></marsBoxFooter>
      </keep-alive>
    </div>
    <div
      class="floating-window"
      v-if="curPosition != 'scratch_program' && curPosition != 'scratch_personal' && curPosition != 'management'"
    >
      <keep-alive>
        <floatingWindow></floatingWindow>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import storeHeader from "@/components/common/store_header_cpn"; //商城头部导航栏
import marsBoxHomeHeader from "@/components/common/mars_box_home_header_cpn"; //首页头部导航栏
import marsBoxFooter from "@/components/common/mars_box_footer_cpn"; //底部导航栏
import floatingWindow from "@/components/common/floating_window_cpn"; //右侧悬浮窗
import insHeader from "@/components/common/ins_header_cpn"; //机构头部导航栏
import insForumHeader from "@/components/common/ins_forum_header_cpn"; //机构论坛头部导航栏
import scratchPersonalHeader from "@/components/common/scratch_personal_header_cpn"; //编程创作个人中心头部导航栏
import scratchProgramHeader from "@/components/common/scratch_program_header_cpn"; //编程创作头部导航栏

export default {
  name: "App",
  data() {
    return {
      curPosition: "",
      isRouterAlive: true,
      curComponentName: ""
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {
    marsBoxHomeHeader,
    marsBoxFooter,
    storeHeader,
    floatingWindow,
    insHeader,
    insForumHeader,
    scratchPersonalHeader,
    scratchProgramHeader
  },
  mounted() {
    // this.setWebIcon();
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
    // setWebIcon: function() {
    //   let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    //   link.type = 'image/x-icon';
    //   link.rel = 'shortcut icon';
    //   link.href = '/static/favicon.ico';
    //   document.getElementsByTagName('head')[0].appendChild(link);
    // }
  },
  watch: {
    $route: function(from) {
      this.curPosition = this.$route.params.type;
      this.curComponentName = this.$route.name;
      // this.setWebIcon();
    }
  }
};
</script>

<style lang="less" scoped>
.mars-box-view {
  width: 100%;
  height: 100%;
  & > .mars-box-center {
    flex: 1 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue